import React from "react";

const CircleChevron = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39">
        <path d="M19.5,39A19.5,19.5,0,1,0,0,19.5,19.5,19.5,0,0,0,19.5,39Zm9.217-18.357a1.826,1.826,0,0,1-2.582,2.582L19.508,16.6l-6.627,6.627A1.826,1.826,0,0,1,10.3,20.643l7.907-7.922a1.821,1.821,0,0,1,2.582,0Z" fill="#fff"/>
    </svg>
}

export default CircleChevron;
